// Port of api/fuel/app/classes/controller/api/monty/users/sync.php
import Constants from '@/offline/constants'
import User from '@/offline/model/user'

export default function(params) {
	let user = null

	if(params.id) {
		user = User.find(params.id)
	} else if(params.name) {
		const name = params.name.trim().toLowerCase()

		user = User.query().whereRaw('LOWER(user_name) = ?', [name]).first()
			|| User.query().whereRaw('LOWER(user_slug) = ?', [name]).first()
	}

	if(!user) {
		return Promise.reject({ error: Constants.API_ERROR_USER_NOTFOUND, offline: true })
	}

	if(user.has_synchronised()) {
		return Promise.resolve({
			session: { offline: true },
			data: user.to_array(),
		})
	}

	return Promise.reject({ error: Constants.API_ERROR_SYNC_FAIL, offline: true })
}
